// Centralized extension store URLs and browser detection

export const EXTENSION_URLS = {
  chrome: 'https://chromewebstore.google.com/detail/blackmount-%E2%80%93-save-restore/fpchhlhegjjjkfnhcdgfjcbinhhmfccc',
  firefox: 'https://addons.mozilla.org/en-US/firefox/addon/blackmount/',
  edge: 'https://microsoftedge.microsoft.com/addons/detail/blackmount-%E2%80%93-save-resto/joehjcmaaehannjlhaaiikflfhcamdoh',
};

export const APP_STORE_URL = 'https://apps.apple.com/us/app/blackmount/id6759819601';

export function detectBrowser() {
  const ua = navigator.userAgent;
  if (ua.includes('Firefox')) return 'firefox';
  if (ua.includes('Edg')) return 'edge';
  if (ua.includes('Chrome')) return 'chrome';
  return 'chrome';
}

export function getExtensionUrl(browser) {
  return EXTENSION_URLS[browser] || EXTENSION_URLS.chrome;
}

export function getBrowserLabel(browser) {
  const labels = { chrome: 'Chrome', firefox: 'Firefox', edge: 'Edge' };
  return labels[browser] || 'Chrome';
}
